export const animateAnswer = (fullAnswer, setQaHistory) => {
	let i = 0;
	const interval = setInterval(() => {
		setQaHistory((prev) => {
			const last = prev[prev?.length - 1];
			if (!last) return prev;
			const updated = {
				...last,
				displayedAnswer: fullAnswer?.slice(0, i + 1),
				isLoading: i + 1 < fullAnswer?.length
			};
			return [...prev.slice(0, -1), updated];
		});
		i++;
		if (i >= fullAnswer?.length) clearInterval(interval);
	}, 10);
};

export const formatSopResponse = (text) => {
	if (!text) return '';

	let formattedText = text;

	formattedText = formattedText.replace(
		/(?:phone at|Phone No:|phone:|Phone:)?\s*(\d{10,})/gi,
		'___PHONE___$1___'
	);

	formattedText = formattedText.replace(/(\d+)\.\*\*(.*?)\*\*/g, '<li><strong>$2</strong></li>');

	formattedText = formattedText.replace(/(\d+)\.(.*?)(?=\d+\.|$)/g, '<li>$2</li>');

	formattedText = formattedText.replace(/(<li>.*?<\/li>)+/g, (match) => {
		return `<ol>${match}</ol>`;
	});

	formattedText = formattedText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

	formattedText = formattedText.replace(/\n/g, '<br>');

	formattedText = formattedText.replace(/<li>(.*?)<\/li>(?!\s*<ol>)/g, '<p>$1</p>');

	formattedText = formattedText.replace(/___PHONE___(\d+)___/g, '$1');

	return `<div class="sop-formatted-content">${formattedText}</div>`;
};
